/**
 *
 *
 *
 *
 */
export function preventClickBubbling(tag: HTMLElement) {
    tag.addEventListener("click", (event) => {
        event.stopPropagation();
        event.preventDefault();
    });
}
